enum RiskDegreeEnum {
  SAFE = 'safe',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export default RiskDegreeEnum;
